  import { Component, OnInit } from '@angular/core';
  import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
  import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-handicraft-detail',
  templateUrl: './handicraft-detail.component.html',
  styleUrls: ['./handicraft-detail.component.sass']
})
export class HandicraftDetailComponent implements OnInit {
  producerDocId;

  handicraftDocId;
  handicraftDoc;
  handicraftCol;
  pictureCol;
  
  coverPhoto: string = "./assets/img/no-cover.png";
  profilePhoto: string = "./assets/img/no-logo.png";
  //email: string = 'moses@pngl.com';

  logoImage: string = "./assets/img/no-logo.png";
  coverImage: string = "./assets/img/no-cover.png";
  

  constructor(
    public db: FirestoreService,
    public route: Router,
    public aroute: ActivatedRoute
    ) {}

  ngOnInit(): void {
    this.handicraftDocId = this.aroute.snapshot.paramMap.get('id');
    this.handicraftDoc = this.db.getMainDoc('storeproducts', this.handicraftDocId); 
    this.pictureCol = this.db.getSubCol('storeproducts', this.handicraftDocId, 'productPictures');
    //console.log(this.pictureCol);
    this.db.getDocId('storeproducts', this.handicraftDocId)
    .then(data=>{
      this.producerDocId = data.ownerDocId;
      this.handicraftCol = this.db.getMainColWhere('storeproducts', 'ownerDocId', this.producerDocId);
    })
  }

  scrollToTop(){
    this.route.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
    });  
  }
  
  reloadComponent() {
    let currentUrl = this.route.url;
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.onSameUrlNavigation = 'reload';
    this.route.navigate([currentUrl]);
  }

  routeToDetailPage(docId){
    this.route.navigateByUrl('handicraft/'+docId);
  };
  routeHandicraftDetailPage(docId){
    
    this.route.navigateByUrl('handicraft/'+docId)
    .then(res =>{
      this.reloadComponent()
    })
    .then(res =>{
      this.scrollToTop()
    })
  }

}
